import { render, staticRenderFns } from "./deploy.vue?vue&type=template&id=01c5da4d&"
import script from "./deploy.vue?vue&type=script&lang=js&"
export * from "./deploy.vue?vue&type=script&lang=js&"
import style0 from "./deploy.vue?vue&type=style&index=0&id=01c5da4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports